import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import S from './style';
import Logo from '../../assets/logo.svg';
import TranslateStatic from '../../locales/TranslateStatic';
import LangChanger from './LangChanger';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

function Header(props) {
    const [menuOpen, setMenuOpen] = useState(false);
    const [corporateOpen, setCorporateOpen] = useState(false);
    const [servicesOpen, setServicesOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false);
    const { pathname } = useLocation();

    const toggleMenu = () => setMenuOpen(!menuOpen);
    const closeMenu = () => setMenuOpen(false);

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 50) {
                setScrolled(true);
            } else {
                setScrolled(false);
            }
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    // Route değişiminde menüyü kapat
    useEffect(() => {
        setMenuOpen(false);
    }, [pathname]);

    // Mobil menü açıkken body scrollunu kilitle
    useEffect(() => {
        if (menuOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
        }
        return () => {
            document.body.style.overflow = '';
        };
    }, [menuOpen]);

    const isLightText = pathname === '/' && !scrolled;

    return (
        <S.Wrapper isHome={pathname === '/'} fontColor={isLightText} menuOpen={menuOpen}>
            <S.Logo href='/'>
                <img src={Logo} alt="Gelecek Tüp Bebek Logo" />
            </S.Logo>

            {/* Desktop Navigation */}
            <S.DesktopNav fontColor={isLightText}>
                <li>
                    <Link to="/"><TranslateStatic string="home" /></Link>
                </li>
                <li>
                    <Link to="/aboutus"><TranslateStatic string="aboutus" /></Link>
                </li>
                <li>
                    <Link to="/team"><TranslateStatic string="products" /></Link>
                </li>
                <li>
                    <Link to="/ilac"><TranslateStatic string="IlacAnlatimiBaslik" /></Link>
                </li>

                {/* Kurumsal Dropdown */}
                <li>
                    <div className="dropdown">
                        <span><TranslateStatic string="institutional" /></span>
                        <KeyboardArrowDownIcon style={{ fontSize: 16 }} />
                        <div className="dropdown-menu">
                            <Link to="/yumurtlama"><TranslateStatic string="yumurtlamanın uyarılması" /></Link>
                            <Link to="/genetiktarama"><TranslateStatic string="genetik tarama" /></Link>
                            <Link to="/asilama"><TranslateStatic string="aşılama" /></Link>
                            <Link to="/donduraraksaklama"><TranslateStatic string="dondurarak saklama" /></Link>
                            <Link to="/endoskopikameliyatlar"><TranslateStatic string="endoskopik ameliyatlar" /></Link>
                            <Link to="/tesa"><TranslateStatic string="TESA / MIKRO TESE" /></Link>
                            <Link to="/tupbebek"><TranslateStatic string="tüp bebek tedavisi" /></Link>
                            <Link to="/uremeguclugu"><TranslateStatic string="UremeGucluguHeader" /></Link>
                            <Link to="/ekt"><TranslateStatic string="ektedaviler" /></Link>
                            <Link to="/tedavisureci"><TranslateStatic string="TedaviSureci" /></Link>
                            <Link to="/ameliyatlar"><TranslateStatic string="Ameliyatlar" /></Link>
                        </div>
                    </div>
                </li>

                {/* Hizmetler Dropdown */}
                <li>
                    <div className="dropdown">
                        <span><TranslateStatic string="services" /></span>
                        <KeyboardArrowDownIcon style={{ fontSize: 16 }} />
                        <div className="dropdown-menu">
                            <Link to="/category"><TranslateStatic string="BilimselToplantı" /></Link>
                            <Link to="/support"><TranslateStatic string="EgitimDestekLow1" /></Link>
                        </div>
                    </div>
                </li>

                <li>
                    <Link to="/sss"><TranslateStatic string="SSS" /></Link>
                </li>
                <li>
                    <Link to="/contactus"><TranslateStatic string="contact" /></Link>
                </li>
            </S.DesktopNav>

            {/* Sağ Alan: Dil Seçici & Mobil Hamburger Butonu */}
            <S.RightSection>
                <S.LangWrapper>
                    <LangChanger lang={props.lang} changeLanguage={props.changeLanguage} />
                </S.LangWrapper>

                <S.HamburgerButton 
                    onClick={toggleMenu} 
                    isOpen={menuOpen} 
                    fontColor={isLightText}
                    aria-label="Toggle Menu"
                >
                    {menuOpen ? <CloseIcon /> : <MenuIcon />}
                </S.HamburgerButton>
            </S.RightSection>

            {/* Mobil Menü Karartma Katmanı (Backdrop) */}
            <S.DrawerOverlay isOpen={menuOpen} onClick={closeMenu} />

            {/* Mobil Menü Çekmecesi (Drawer) */}
            <S.Drawer isOpen={menuOpen}>
                <S.DrawerHeader>
                    <div className="drawer-logo">
                        <img src={Logo} alt="Gelecek Logo" />
                    </div>
                    <button className="close-btn" onClick={closeMenu} aria-label="Menüyü Kapat">
                        <CloseIcon />
                    </button>
                </S.DrawerHeader>

                <S.DrawerBody>
                    <S.DrawerItem onClick={closeMenu}>
                        <Link to="/"><TranslateStatic string="home" /></Link>
                    </S.DrawerItem>
                    <S.DrawerItem onClick={closeMenu}>
                        <Link to="/aboutus"><TranslateStatic string="aboutus" /></Link>
                    </S.DrawerItem>
                    <S.DrawerItem onClick={closeMenu}>
                        <Link to="/team"><TranslateStatic string="products" /></Link>
                    </S.DrawerItem>
                    <S.DrawerItem onClick={closeMenu}>
                        <Link to="/ilac"><TranslateStatic string="IlacAnlatimiBaslik" /></Link>
                    </S.DrawerItem>

                    {/* Mobil Kurumsal Akordiyon */}
                    <S.DrawerAccordion>
                        <S.DrawerAccordionButton 
                            isOpen={corporateOpen} 
                            onClick={() => setCorporateOpen(!corporateOpen)}
                        >
                            <span><TranslateStatic string="institutional" /></span>
                            <KeyboardArrowDownIcon className="chevron" />
                        </S.DrawerAccordionButton>
                        <S.DrawerSubmenu isOpen={corporateOpen}>
                            <Link to="/yumurtlama" onClick={closeMenu}><TranslateStatic string="yumurtlamanın uyarılması" /></Link>
                            <Link to="/genetiktarama" onClick={closeMenu}><TranslateStatic string="genetik tarama" /></Link>
                            <Link to="/asilama" onClick={closeMenu}><TranslateStatic string="aşılama" /></Link>
                            <Link to="/donduraraksaklama" onClick={closeMenu}><TranslateStatic string="dondurarak saklama" /></Link>
                            <Link to="/endoskopikameliyatlar" onClick={closeMenu}><TranslateStatic string="endoskopik ameliyatlar" /></Link>
                            <Link to="/tesa" onClick={closeMenu}><TranslateStatic string="TESA / MIKRO TESE" /></Link>
                            <Link to="/tupbebek" onClick={closeMenu}><TranslateStatic string="tüp bebek tedavisi" /></Link>
                            <Link to="/uremeguclugu" onClick={closeMenu}><TranslateStatic string="UremeGucluguHeader" /></Link>
                            <Link to="/ekt" onClick={closeMenu}><TranslateStatic string="ektedaviler" /></Link>
                            <Link to="/tedavisureci" onClick={closeMenu}><TranslateStatic string="TedaviSureci" /></Link>
                            <Link to="/ameliyatlar" onClick={closeMenu}><TranslateStatic string="Ameliyatlar" /></Link>
                        </S.DrawerSubmenu>
                    </S.DrawerAccordion>

                    {/* Mobil Hizmetler Akordiyon */}
                    <S.DrawerAccordion>
                        <S.DrawerAccordionButton 
                            isOpen={servicesOpen} 
                            onClick={() => setServicesOpen(!servicesOpen)}
                        >
                            <span><TranslateStatic string="services" /></span>
                            <KeyboardArrowDownIcon className="chevron" />
                        </S.DrawerAccordionButton>
                        <S.DrawerSubmenu isOpen={servicesOpen}>
                            <Link to="/category" onClick={closeMenu}><TranslateStatic string="BilimselToplantı" /></Link>
                            <Link to="/support" onClick={closeMenu}><TranslateStatic string="EgitimDestekLow1" /></Link>
                        </S.DrawerSubmenu>
                    </S.DrawerAccordion>

                    <S.DrawerItem onClick={closeMenu}>
                        <Link to="/sss"><TranslateStatic string="SSS" /></Link>
                    </S.DrawerItem>
                    <S.DrawerItem onClick={closeMenu}>
                        <Link to="/contactus"><TranslateStatic string="contact" /></Link>
                    </S.DrawerItem>
                </S.DrawerBody>
            </S.Drawer>
        </S.Wrapper>
    );
}

export default Header;